import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";
import config from "config/config";
import { useTranslations, useLanguage } from "contexts/LocalizationContext/hooks";
import { getLocalizedLogotypes } from "../../utils";

const { Image, Text, Flex } = Chakra;

const PressLogos = ({ textColor }) => {
  const translations = useTranslations();
  const language = useLanguage();
  const logotypes = getLocalizedLogotypes(language);

  return (
    <>
      <Text
        textTransform="uppercase"
        fontWeight="bold"
        letterSpacing="wider"
        fontSize="sm"
        lineHeight={8}
        my={3}
        mx={2}
        color={textColor}
        data-testid="media-bar-text"
      >
        {translations("airhelp_has_been_featured")}
      </Text>
      <Flex flexWrap="wrap" justify="center" data-testid="media-logos">
        {logotypes.map(({ alt, imgPath }) => (
          <Image
            key={alt}
            src={`${config.staticUrl}/i/press/${imgPath}`}
            alt={alt}
            htmlWidth="208px"
            htmlHeight={8}
            h={8}
            my={3}
            mx={1}
            loading="lazy"
            data-testid="media-bar-source"
          />
        ))}
      </Flex>
    </>
  );
};

export default PressLogos;

PressLogos.propTypes = {
  textColor: PropTypes.string,
};

PressLogos.defaultProps = {
  textColor: "",
};
